import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { companyInfo, contactInfo } from '../data/companyData';

export const Footer = () => {
  const footerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <motion.footer 
      className="bg-tev-green text-white py-16"
      variants={footerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <motion.div variants={itemVariants}>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name} 
                className="h-12 w-12 object-contain"
              />
              <h4 className="text-xl font-bold">{companyInfo.name}</h4>
            </div>
            <p className="text-green-100 leading-relaxed">
              {companyInfo.tagline}
            </p>
          </motion.div>
          
          <motion.div variants={itemVariants}>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/who-we-are" className="text-green-100 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/sbus" className="text-green-100 hover:text-white transition-colors">SBUs</Link></li>
              <li><Link to="/contact" className="text-green-100 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </motion.div>
          
          <motion.div variants={itemVariants}>
            <h4 className="text-lg font-semibold mb-4">Operations</h4>
            <ul className="space-y-2 text-green-100">
              <li>Malawi</li>
              <li>Mozambique</li>
              <li>Zambia</li>
              <li>Regional Markets</li>
            </ul>
          </motion.div>
          
          <motion.div variants={itemVariants}>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-green-100">
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt mr-2 mt-1"></i>
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-envelope mr-2"></i>
                {contactInfo.email}
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone mr-2"></i>
                {contactInfo.phone}
              </li>
            </ul>
          </motion.div>
        </div>
        
        <motion.div 
          className="border-t border-green-800 pt-8 text-center text-green-100"
          variants={itemVariants}
        >
          <p>&copy; 2025 {companyInfo.name}. All rights reserved. | {contactInfo.website}</p>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
